export default "/dist/bb5e19dfed8943f9637f7da893505fff.png";